export const state = {
  activeQuestionId: '',
  sectionCount: 0,
  progress: 0,
  questions: [],
  answeredQuestions: [],
  answersSummary: []
};

export const mutations = {
  setActiveQuestionId(state, payload) {
    state.activeQuestionId = payload;
  },
  setSectionCount(state, payload) {
    state.sectionCount = payload;
  },
  setProgress(state) {
    if (!state.answeredQuestions.length) {
      state.progress = 0;
      return;
    }
    const totalQuestions = state.questions.length > 5 ? 5 : state.questions.length;
    const lastAnsweredQuestionId = state.answeredQuestions[state.answeredQuestions.length - 1].questionId;
    const lastAnsweredQuestion = state.questions.find(element => element.id === lastAnsweredQuestionId);
    if (lastAnsweredQuestion !== undefined) {
      state.progress = (state.answeredQuestions.length * 100) / totalQuestions;
    }
  },
  addQuestionToList(state, payload) {
    state.questions = [].concat(...state.questions, [payload]);
  },
  addAnsweredQuestionToList(state, payload) {
    const answeredQuestion = state.answeredQuestions.find(element => element.id === payload.questionId);
    if (answeredQuestion !== undefined) {
      answeredQuestion.answers = payload.answers;
      return;
    }
    state.answeredQuestions = [].concat(...state.answeredQuestions, [payload]);
    payload.answers.forEach(answer => {
      state.answersSummary.push(answer);
    });
  },
  regress(state) {
    if (state.answeredQuestions.length) {
      const lastAnsweredQuestion = state.answeredQuestions[state.answeredQuestions.length - 1];
      const lastAnsweredQuestionId = lastAnsweredQuestion.questionId;
      if (lastAnsweredQuestionId !== undefined) {
        state.activeQuestionId = lastAnsweredQuestionId;
        lastAnsweredQuestion.answers.forEach(answer => {
          var index = state.answersSummary.indexOf(answer);
          state.answersSummary.splice(index, 1);
        });
        state.answeredQuestions.pop();
      }
    }
  }
};

export const actions = {
  setActiveQuestionId({ commit }, payload) {
    commit('setProgress');
    commit('setActiveQuestionId', payload);
  },
  addQuestionToList({ commit }, payload) {
    commit('addQuestionToList', payload);
  },
  setSectionCount({ commit }, payload) {
    commit('setSectionCount', payload);
  },
  addAnsweredQuestionToList({ commit }, payload) {
    commit('addAnsweredQuestionToList', payload);
  },
  regress({ commit }) {
    commit('regress');
    commit('setProgress');
  },
  setProgress({ commit }) {
    commit('setProgress');
  }
};
export const getters = {
  activeQuestionId: (state) => state.activeQuestionId,
  questions: (state) => state.questions,
  sectionCount: (state) => state.sectionCount,
  progress: (state) => state.progress,
  answersSummary: (state) => state.answersSummary,
  answeredQuestionsCount: (state) => state.answeredQuestions.length + 1
};

export default  {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
